import { dataBeforeSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBeforeSquare = /*#__PURE__*/createIcon(dataBeforeSquare)
export default IconBeforeSquare
